import { useToast } from 'context/tostifyContext';
import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '../../../constants/ActionTypes';
import { useDispatch } from 'react-redux';

function useAssignRole() {
  const [allUsers, setAllUsers] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  const [editingUserId, setEditingUserId] = useState(null);
  const [selectedRoleId, setSelectedRoleId] = useState('');

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [openResetModal, setOpenResetModal] = useState(false);
  const [resetPasswordData, setResetPasswordData] = useState({ password: '', confirmPassword: '' });
  const [resetPasswordError, setResetPasswordError] = useState('');

  const { showToast } = useToast();
  const dispatch = useDispatch();

  useEffect(() => {
    getUsers();
    getRoles();
  }, []);

  const getUsers = async () => {
    try {
      const res = await customAxios.get('/User/GetAllUsers', { headers: authHeader() });
      setAllUsers(res.data || []);
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  const getRoles = async () => {
    try {
      const res = await customAxios.get('/User/GetAllRoles', { headers: authHeader() });
      setAllRoles(res.data || []);
    } catch (err) {
      console.error('Error fetching roles:', err);
    }
  };

  const handleEditClick = userId => {
    setEditingUserId(userId);
    setSelectedRoleId('');
  };

  const handleRoleChange = roleId => {
    setSelectedRoleId(roleId);
  };

  const handleSaveRole = async userId => {
    if (selectedRoleId === '') return;
    const role = allRoles.find(el => selectedRoleId === el.id);
    const selectedUser = allUsers.find(el => userId === el.userId);
    console.log("selectedUser", selectedUser);
    try {

      // const payload = {
      //   userId: userId,
      //   roleName: role.rolename,
      //   defaultTruck: string,
      //   defaultLoader: string,
      //   driverID: string,
      //   isDriver: selectedUser.isDriver,
      //   isLoader: selectedUser.isLoader,
      // };

      // try {
      //   const res = await customAxios.post('/User/EditUserRoles', payload, { headers: authHeader() });

      //   console.log(res);
      //   if (res.status === 200) {
      //     showToast('User role changed :');
      //   }
      // } catch (err) {
      //   console.log(err);
      //   showToast('Failed to change role :');
      // }

      // setEditingUserId(null);
      // setSelectedRoleId('');
      // getUsers();
    } catch (err) {
      console.error('Error assigning role:', err);
    }
  };

  const handleCancelEdit = () => {
    setEditingUserId(null);
    setSelectedRoleId('');
  };

  async function handleDeleteUser(userId) {
    try {
      dispatch({ type: FETCH_START });
      const res = await customAxios.post(
        '/User/DeleteUser',
        {
          userIdToDelete: userId,
        },
        { headers: authHeader() },
      );
      showToast('User deleted successfully');
      getUsers();
      setOpenDeleteModal(false);

      dispatch({ type: FETCH_SUCCESS });
    } catch (err) {
      showToast('Failed to delete user', 'error');
      console.log(err);
      setOpenDeleteModal(false);
      dispatch({ type: FETCH_SUCCESS });
    }
  }

  const handleResetPassword = async userId => {
    const { password, confirmPassword } = resetPasswordData;

    if (!password || !confirmPassword) {
      setResetPasswordError('Both fields are required.');
      return;
    }
    if (password !== confirmPassword) {
      setResetPasswordError('Passwords do not match.');
      return;
    }

    try {
      dispatch({ type: FETCH_START });
      const res = await customAxios.post(
        '/User/ResetPassword',
        { userId, newPassword: password, confirmNewPassword: confirmPassword },
        { headers: authHeader() },
      );
      if (res.status === 200) {
        showToast('Password reset successfully');
      }
      setOpenResetModal(false);
      setResetPasswordData({ password: '', confirmPassword: '' });
      setResetPasswordError('');
      dispatch({ type: FETCH_SUCCESS });
    } catch (err) {
      showToast('Failed to reset password', 'error');
      console.error(err);
      dispatch({ type: FETCH_SUCCESS });
    }
  };

  const handleUpdateUser = async payload => {
    try {
      dispatch({ type: FETCH_START });
      const res = await customAxios.post('/User/EditUser', payload, { headers: authHeader() });

      if (res.status === 200) {
        showToast('User updated successfully');
        await getUsers(); // refresh the table
        return true;
      }
      throw new Error(`Unexpected status ${res.status}`);
    } catch (err) {
      console.error('Error updating user:', err);
      showToast('Failed to update user', 'error');
      throw err; // lets the dialog stay open
    } finally {
      dispatch({ type: FETCH_SUCCESS }); // hides the loader on both paths, like your other handlers
    }
  };

  return {
    allUsers,
    allRoles,
    editingUserId,
    handleEditClick,
    selectedRoleId,
    handleRoleChange,
    handleSaveRole,
    handleCancelEdit,
    handleDeleteUser,
    openDeleteModal,
    setOpenDeleteModal,
    selectedUserId,
    setSelectedUserId,
    openResetModal,
    setOpenResetModal,
    resetPasswordData,
    setResetPasswordData,
    resetPasswordError,
    handleResetPassword,
    handleUpdateUser
  };
}

export default useAssignRole;
